import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { HiredBadge } from '@/components/transport/DashboardBits';

const num = (v, d = 1) => (v == null ? '—' : Number(v).toLocaleString('en-IN', { maximumFractionDigits: d }));
const Fill = ({ date, odo }) => (date ? <span>{date}<span className="block text-[11px] text-gray-500">{num(odo, 0)} km</span></span> : '—');

export const FuelEfficiencyReport = ({ data }) => {
  const rows = data?.rows || [];
  const f = data?.fleet;
  return (
    <div data-testid="fe-report">
      {f && <p className="text-sm text-gray-500 mb-2" data-testid="fe-fleet">
        Fleet: <strong>{num(f.km)} km</strong> on <strong>{num(f.litres_counted, 2)} L</strong> = <strong data-testid="fe-fleet-kmpl">{f.kmpl ?? '—'} km/L</strong>
        <span className="ml-2 text-xs">Distance = last fill odometer − first fill odometer · litres = fuel filled after the first fill</span>
      </p>}
      <Card className="border-0 shadow-md"><CardContent className="p-0">
        <Table data-testid="fe-report-table">
          <TableHeader><TableRow>
            <TableHead>Vehicle</TableHead><TableHead>Type</TableHead><TableHead>Fills</TableHead><TableHead>First fill</TableHead>
            <TableHead>Last fill</TableHead><TableHead>Distance (km)</TableHead><TableHead>Litres (after first)</TableHead>
            <TableHead>Km/L</TableHead><TableHead>Fuel ₹/km</TableHead><TableHead>Odometer issues</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.vehicle_id} data-testid={`fe-row-${r.vehicle_id}`}>
                <TableCell className="whitespace-nowrap font-medium">{r.registration_no}<HiredBadge ownership={r.ownership} testId={`fe-hired-${r.vehicle_id}`} /></TableCell>
                <TableCell>{r.vehicle_type}</TableCell><TableCell>{r.fills}</TableCell>
                <TableCell><Fill date={r.first_date} odo={r.first_odo} /></TableCell>
                <TableCell><Fill date={r.last_date} odo={r.last_odo} /></TableCell>
                <TableCell data-testid={`fe-km-${r.vehicle_id}`}>{num(r.km)}</TableCell>
                <TableCell>{r.km != null ? num(r.litres_counted, 2) : '—'}</TableCell>
                <TableCell data-testid={`fe-kmpl-${r.vehicle_id}`}>{r.kmpl != null ? <strong>{r.kmpl}</strong> : <span className="text-[11px] text-gray-400">needs 2 fills with odometer</span>}</TableCell>
                <TableCell>{r.cost_per_km != null ? `₹${r.cost_per_km}` : '—'}</TableCell>
                <TableCell data-testid={`fe-issues-${r.vehicle_id}`}>{r.odo_issues || '—'}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={10} className="text-center text-gray-400 py-8" data-testid="fe-empty">No fuel fills in this range.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
      <p className="text-[11px] text-gray-400 mt-2">A fill whose odometer is missing or not higher than the previous fill is counted as an odometer issue and skipped as a reading.</p>
    </div>
  );
};
